export const SharedViewSwitcher = {
  flow: 'x',
  borderWidth: '1px',
  borderColor: 'line',
  borderStyle: 'solid',
  round: 'Z',
  overflow: 'hidden',
  stateKey: 'viewMode',
  mode: 'state'
}

const _stateKey = (el) => (el.parent && el.parent.stateKey) || 'viewMode'
const _mode = (el) => (el.parent && el.parent.mode) || 'state'
const _isActive = (el, s) => {
  const root = s && s.root
  if (!root) return false
  if (_mode(el) === 'route') return root.route === el.value
  return root[_stateKey(el)] === el.value
}

// Active state is driven by reactive CSS prop factories rather than
// `isActive` + `.isActive`. smbls v3.14 only wires reactive effects for
// function props that are in the CSS_PROPS_REGISTRY — `isActive` is a
// custom boolean flag, so `applyConditionals` runs the check ONCE at
// creation and freezes it. `background`, `color`, `fontWeight` ARE in
// the registry, so their factories re-run on state change.
export const SharedViewSwitcherBtn = {
  tag: 'button',
  type: 'button',
  flow: 'x',
  align: 'center center',
  gap: 'Z',
  padding: 'Z A',
  border: 'none',
  cursor: 'pointer',
  fontSize: 'Z2',
  background: (el, s) => _isActive(el, s) ? 'overlayStrong' : 'transparent',
  color: (el, s) => _isActive(el, s) ? 'title' : 'caption',
  fontWeight: (el, s) => _isActive(el, s) ? '600' : '400',
  ':hover': { color: 'title', background: 'overlay' },

  Icon: {
    display: (el) => (el.parent && el.parent.icon) ? 'inline-flex' : 'none',
    icon: (el) => (el.parent && el.parent.icon) || 'state',
    boxSize: 'Z2'
  },
  Label: { tag: 'span', text: (el) => (el.parent && el.parent.label) || '' },

  onClick: (e, el, s) => {
    e.preventDefault()
    e.stopPropagation()
    if (!s || !s.root) return
    if (_mode(el) === 'route') {
      el.router(el.value, el.getRoot(), {}, { pushState: true, scrollToTop: true })
      return
    }
    s.root.update({ [_stateKey(el)]: el.value })
  }
}
